import { useEffect, useState } from "react";

/** The phone query shared with global.css's 16px-input and 44px-tap-target rules: portrait phones
 *  below 768, plus touch screens under 500px tall (landscape phones, wider than 768). */
export const PHONE_TAP_QUERY = "(max-width: 767px), (pointer: coarse) and (max-height: 500px)";

/** True while the media query matches; follows resizes and rotation. */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
